import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  constructor(private _snackBar: MatSnackBar, private translateService: TranslateService) {}
  showErrorSnackBar(message = 'An error has occurred, please try again.'): void {
    this._snackBar.open(
      this.translateService.instant(message) as string,
      this.translateService.instant('Accept') as string,
      {
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        duration: 5000,
      }
    );
  }

  showSuccesSnackbar(message: string) {
    this._snackBar.open(this.translateService.instant(message) as string, this.translateService.instant('close') as string, {
      duration: 3000,
    });
  }
}
